export const FOOTER_TEST_IDS = {
    FOOTER: 'footer',
    SOCIAL: 'footer-social',
    NAVIGATION: 'footer-navigation',
    CONTACTS: 'footer-contacts',
    ADDITIONAL: 'footer-additional',
};
